import { render, staticRenderFns } from "./ClientFinancialInformation.vue?vue&type=template&id=584f99f5&scoped=true&"
import script from "./ClientFinancialInformation.vue?vue&type=script&lang=ts&"
export * from "./ClientFinancialInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f99f5",
  null
  
)

export default component.exports